import { IconCode, IconSettings } from '@tabler/icons-react';

import { useNavigate } from 'react-router-dom';

import { Button, Flex, Text } from '@mantine/core';

import { IdentityGuard } from './auth/IdentityGuard.tsx';
import { IdentityType } from './auth/IdentityType.tsx';
import { adminSettingsRoute } from './utils/RouteResolverUtils.tsx';

export const Footer = () => {
    const navigate = useNavigate();

    return (
        <Flex
            direction={'row'}
            gap={'md'}
            align={'center'}
            justify={'center'}
            h='100%'
        >
            <Text size='xs' c='dimmed'>&copy; 2025 Firefinch Software</Text>

            <IdentityGuard targets={[IdentityType.Admin]}>
                <Button
                    leftSection={<IconSettings size={14} />}
                    variant='subtle'
                    color='gray'
                    size='xs'
                    onClick={() => navigate(adminSettingsRoute)}
                >
                    Admin Settings
                </Button>
                <Button
                    leftSection={<IconCode size={14} />}
                    variant='subtle'
                    color='gray'
                    size='xs'
                    component='a'
                    href='/swagger'
                    target='_blank'
                >
                    Swagger
                </Button>
            </IdentityGuard>
        </Flex>
    );
};
